import { SagaReturnType, call, put, takeEvery } from 'redux-saga/effects';
import therapistService from '../../../services/apiServices/therapist-scheduling/therapistService';
import { TherapistAction } from '../../actions/constant';

const {
  GET_PAYCOME_PROVIDER_REQUEST,
  GET_PAYCOME_PROVIDER_SUCCESS,
  GET_PAYCOME_PROVIDER_FAILURE,
  GET_PAYCOME_PROVIDER_LOADER,
  GET_PAYCOME_PROVIDER_RESET,
} = TherapistAction;

function* getPayComeDetails(): SagaReturnType<any> {
  try {
    const response = yield call(therapistService.getPayComeDetails);
    if (response?.status === 200) {
      yield put({ type: GET_PAYCOME_PROVIDER_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_PAYCOME_PROVIDER_FAILURE, payload: error });
  }
}

function* getPayComeDetailsSaga() {
  yield takeEvery(GET_PAYCOME_PROVIDER_REQUEST, getPayComeDetails);
}

export default getPayComeDetailsSaga;
